import {ReloadButton,} from '@flexinet/ui-components';

import {Box,} from '@mantine/core';

import {useDomainNames} from '../hooks/useDomainNames';

export const ReloadRecordsButton = () => {

    const {fetchRecords} = useDomainNames();
    return (
        <Box mx='s'>
            <ReloadButton onClick={() => fetchRecords()}/>
        </Box>
    );
};
